<template>
    <div style="padding: 10px 10px 0px 10px; background: white">
        <el-tabs type="card" v-model="activeName" style="background: white">
            <el-tab-pane :label='$i18n.t("common.RegisteredUser")' name="first">
                <registerUser />
            </el-tab-pane>
            <el-tab-pane :label='$i18n.t("common.GuestUser")' name="second">
                <touristUser />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import registerUser from '@/views/userManagement/registerUser.vue';
import touristUser from '@/views/userManagement/touristUser.vue';

export default {
    name: 'regUser',
    components: { registerUser, touristUser },
    data() {
        return {
            activeName: 'first'
        };
    },
    mounted() {},
    methods: {}
};
</script>
